import type React from 'react';

import { Field } from 'react-final-form';

import { Input } from '#src/app/shared/components/adminShadcn';

import { filterValueValidator } from '../../../../../../../shared/validators';

export const InputField: React.FC<{ fieldName: string; placeholder: string }> = ({ fieldName, placeholder }) => {
	return (
		<Field<string | undefined> name={fieldName} validate={filterValueValidator}>
			{({ input, meta }) => (
				<div className="admin:flex-1">
					<Input
						placeholder={placeholder}
						value={input.value}
						name={input.name}
						onChange={input.onChange}
						type="text"
						className="admin:bg-background"
						aria-invalid={meta.touched && meta.error ? true : undefined}
					/>
					{meta.touched && meta.error ? (
						<p role="alert" className="admin:mt-1 admin:text-xs admin:text-destructive">
							{meta.error as string}
						</p>
					) : null}
				</div>
			)}
		</Field>
	);
};
